import React from "react";
import { useLatest } from "react-use";

export function useAsyncCallbackWithStatus<
  F extends (...args: any) => Promise<any>,
>(
  passedFunction: F
): [(...args: Parameters<F>) => Promise<Awaited<ReturnType<F>>>, boolean] {
  const [isProcessing, setIsProcessing] = React.useState(false);
  const latestPassedFunction = useLatest(passedFunction);

  const functionWithStatus = React.useCallback(
    async (...args: Parameters<F>): Promise<Awaited<ReturnType<F>>> => {
      setIsProcessing(true);
      try {
        return await latestPassedFunction.current(...args);
      } finally {
        setIsProcessing(false);
      }
    },
    [latestPassedFunction]
  );

  return [functionWithStatus, isProcessing] as const;
}
